<template>
  <div
    class="relative flex flex-col align-middle min-w-full shadow rounded-xl border-b border-gray-200 bg-white py-10 md:pr-10 min-h-halfscreen"
  >
    <filtres
      :show="isFilterPopupDisplayed"
      :filters="filters"
      :templates="listTemplates"
      @close="isFilterPopupDisplayed = false"
      @updateBeneficiariesFilter="
        (beneficiariesFilter) => {
          filters.beneficiaries = beneficiariesFilter;
        }
      "
      @updateCompetencesPersoFilter="
        (competencesFilter) => {
          //competencesFilter is an object with {template, domaineIndex and competenceIndex} (For the moment, it works with multi3 template...)
          filters.competences[constants.COMPETENCES_FILTER_TYPES.perso] =
            competencesFilter;
        }
      "
      @updateCompetencesSocioFilter="
        (competencesFilter) => {
          filters.competences[constants.COMPETENCES_FILTER_TYPES.socio] =
            competencesFilter;
        }
      "
      @updateCompetencesProFilter="
        (competencesFilter) => {
          filters.competences[constants.COMPETENCES_FILTER_TYPES.pro] =
            competencesFilter;
        }
      "
    />

    <h3 class="mb-10">Compétences</h3>

    <div
      v-if="
        filters.beneficiaries.length > 0 &&
        (filters.competences.perso.length > 0 ||
          filters.competences.socio.length > 0 ||
          filters.competences.pro.length > 0)
      "
    >
      <div
        v-if="false"
        class="flex justify-center w-full text-gray-600 text-2xl space-x-10 mb-10"
      >
        <div
          class="cursor-pointer"
          :class="{ 'text-indigo-600': displayType === 'table' }"
          @click.stop="displayType = 'table'"
        >
          Tableaux
        </div>
        <div
          class="cursor-pointer"
          :class="{ 'text-indigo-600': displayType === 'chart' }"
          @click.stop="displayType = 'chart'"
        >
          Cartographies
        </div>
      </div>

      <div class="flex justify-center w-full mb-10">
        <action-button
          bg-color="bg-indigo-600"
          bg-color-square="bg-indigo-100"
          icon="options"
          icon-color="text-indigo-600"
          libelle="Filtrer les résultats"
          text-color="text-white"
          @clickAction="isFilterPopupDisplayed = true"
        />
      </div>

      <!-- BEGIN Présentation Tableau -->
      <div
        v-if="displayType === 'table'"
        class="flex flex-col justify-center w-full"
      >
        <div class="w-full flex justify-center items-center my-10">
          <action-button
            bg-color="bg-teal-600"
            bg-color-square="bg-teal-100"
            icon="options"
            icon-color="text-teal-600"
            libelle="Export Excel"
            text-color="text-white"
            @clickAction="saveExcelSwapped()"
          />
        </div>
        <CompetencesLegend />

        <!-- BEGIN Compétences personnelles -->
        <div
          v-if="filters.competences.perso.length > 0"
          class="space-y-10 w-full"
        >
          <div
            class="text-xl text-indigo-600 ml-5 md:ml-10 flex space-x-2 items-center"
          >
            <p>Compétences personnelles</p>
          </div>

          <div
            v-for="template in listFilterTemplateMulti3"
            :key="'templateArray' + template.id"
          >
            <div class="ml-5 md:ml-10 mb-5 md:mb-10 flex justify-between">
              <div class="text-lg">
                {{ template.name }}
              </div>
              <div>
                {{ filters.beneficiaries.length }} bénéficiaire{{
                  filters.beneficiaries.length > 1 ? 's' : ''
                }}
                sélectionné{{ filters.beneficiaries.length > 1 ? 's' : '' }}
              </div>
            </div>

            <!-- BEGIN HEADER -->
            <div
              class="grid grid-cols-12 min-h-16 text-base font-medium items-center border-b border-indigo-600 border-opacity-50"
            >
              <div
                class="col-span-4 md:col-span-2 pl-5 md:pl-10 text-base font-medium"
              >
                Compétences
              </div>
              <div
                class="col-span-1 border-r border-indigo-600 h-full border-opacity-50"
              >
                <div
                  v-if="beneficiariesPageNumber > 0"
                  @click.stop="
                    beneficiariesPageNumber = beneficiariesPageNumber - 1
                  "
                  class="h-full w-full flex items-center justify-center"
                >
                  <icon
                    name="arrow-circle-left"
                    class="text-indigo-600 h-4 w-4 md:h-8 md:w-8 transform hover:scale-125 duration-300 cursor-pointer"
                  />
                </div>
              </div>
              <div
                v-for="(
                  beneficiary, beneficiaryIndex
                ) in paginatedBeneficiaries"
                :key="'listBeneficiaries' + beneficiaryIndex"
                class="col-span-3 md:col-span-1 line-clamp-2 h-full border-r border-indigo-600 px-2"
              >
                <div class="break-words h-full">
                  <p>{{ beneficiary.firstname }}</p>
                  <p>{{ beneficiary.lastname }}</p>
                </div>
              </div>
              <div class="col-span-1">
                <div
                  v-if="
                    8 + beneficiariesPageNumber <=
                    filters.beneficiaries.length - 1
                  "
                  @click.stop="
                    beneficiariesPageNumber = beneficiariesPageNumber + 1
                  "
                  class="h-full w-full flex items-center justify-center"
                >
                  <icon
                    name="arrow-circle-right"
                    class="text-indigo-600 h-4 w-4 md:h-8 md:w-8 transform hover:scale-125 duration-300 cursor-pointer"
                  />
                </div>
              </div>
            </div>
            <!-- END HEADER -->
            <!-- BEGIN CONTENT -->
            <div class="divide-y divide-indigo-600 border-opacity-50">
              <div
                v-for="competence in listCompPersoByTemplate[template.id]"
                :key="
                  'competence-perso' +
                  competence.template.id +
                  competence.domaine +
                  competence.competence
                "
                class="grid grid-cols-12 min-h-12 text-base items-center odd:bg-indigo-100 odd:bg-opacity-50 bg-white"
              >
                <div class="col-span-4 md:col-span-2 pl-5 md:pl-10">
                  {{
                    competence.template.type === 'multi1'
                      ? competence.template.data[0][competence.competence]
                          .libelle
                      : competence.template.data[0][competence.domaine][
                          competence.competence
                        ].libelle ===
                        competence.template.data[0][competence.domaine][0]
                          .libelle
                      ? competence.template.data[0][competence.domaine][
                          competence.competence
                        ].libelle
                      : competence.template.data[0][competence.domaine][0]
                          .libelle +
                        ' - ' +
                        competence.template.data[0][competence.domaine][
                          competence.competence
                        ].libelle
                  }}
                </div>
                <div
                  class="col-span-1 border-r border-indigo-600 border-opacity-50 h-full"
                />
                <div
                  v-for="(
                    beneficiary, beneficiaryIndex
                  ) in paginatedBeneficiaries"
                  :key="
                    'listevaluation-perso' +
                    competence.template.id +
                    competence.domaine +
                    competence.competence +
                    beneficiaryIndex
                  "
                  class="border-r border-indigo-600 border-opacity-50"
                  :class="
                    'col-span-3 md:col-span-1 flex text-center w-full h-full justify-center items-center ' +
                    getLevelByBeneficiaryCompetence(beneficiary, competence)
                      .color
                  "
                >
                  {{
                    getLevelByBeneficiaryCompetence(beneficiary, competence)
                      .level
                  }}
                </div>
                <div class="col-span-1" />
              </div>
            </div>

            <!-- END CONTENT -->
          </div>
        </div>
        <!-- END Compétences personnelles -->

        <!-- BEGIN Compétences socio-professionnelles -->
        <div
          v-if="filters.competences.socio.length > 0"
          class="mt-15 space-y-10"
        >
          <div class="text-xl text-indigo-600 ml-10">
            Compétences socio-professionnelles
          </div>

          <div
            v-for="template in listFilterTemplateMulti2"
            :key="'templateArray' + template.id"
          >
            <div class="ml-5 md:ml-10 mb-5 md:mb-10 flex justify-between">
              <div class="text-lg">
                {{ template.name }}
              </div>
              <div>
                {{ filters.beneficiaries.length }} bénéficiaire{{
                  filters.beneficiaries.length > 1 ? 's' : ''
                }}
                sélectionné{{ filters.beneficiaries.length > 1 ? 's' : '' }}
              </div>
            </div>

            <!-- BEGIN HEADER -->
            <div
              class="grid grid-cols-12 min-h-16 text-base font-medium items-center border-b border-indigo-600 border-opacity-50"
            >
              <div
                class="col-span-4 md:col-span-2 pl-5 md:pl-10 text-base font-medium"
              >
                Compétences
              </div>
              <div
                class="col-span-1 border-r border-indigo-600 h-full border-opacity-50"
              >
                <div
                  v-if="beneficiariesPageNumber > 0"
                  @click.stop="
                    beneficiariesPageNumber = beneficiariesPageNumber - 1
                  "
                  class="h-full w-full flex items-center justify-center"
                >
                  <icon
                    name="arrow-circle-left"
                    class="text-indigo-600 h-8 w-8 transform hover:scale-125 duration-300 cursor-pointer"
                  />
                </div>
              </div>
              <div
                v-for="(
                  beneficiary, beneficiaryIndex
                ) in paginatedBeneficiaries"
                :key="'listBeneficiaries' + beneficiaryIndex"
                class="col-span-3 md:col-span-1 line-clamp-2 h-full border-r border-indigo-600"
              >
                <p class="break-words h-full text-center">
                  {{ beneficiary.firstname }} <br />
                  {{ beneficiary.lastname }}
                </p>
              </div>
              <div class="col-span-1">
                <div
                  v-if="
                    8 + beneficiariesPageNumber <=
                    filters.beneficiaries.length - 1
                  "
                  @click.stop="
                    beneficiariesPageNumber = beneficiariesPageNumber + 1
                  "
                  class="h-full w-full flex items-center justify-center"
                >
                  <icon
                    name="arrow-circle-right"
                    class="text-indigo-600 h-8 w-8 transform hover:scale-125 duration-300 cursor-pointer"
                  />
                </div>
              </div>
            </div>
            <!-- END HEADER -->
            <!-- BEGIN CONTENT -->
            <div class="divide-y divide-indigo-600 border-opacity-50">
              <div
                v-for="competenceSocio in listCompSocioProByTemplate[
                  template.id
                ]"
                :key="
                  'competence-socio' +
                  competenceSocio.template.id +
                  competenceSocio.competence
                "
                class="grid grid-cols-12 min-h-12 text-base items-center odd:bg-indigo-100 odd:bg-opacity-50 bg-white"
              >
                <div
                  class="col-span-4 md:col-span-2 my-2 pl-1 md:pl-2 flex space-x-2 items-center"
                >
                  <info-bulle
                    :name="
                      'full-libelle-socio-pro' +
                      competenceSocio.template.id +
                      competenceSocio.competence
                    "
                    :libelle="
                      competenceSocio.template.data[0].filter(
                        $filterEvaluationIntitulesMulti2
                      )[0].criterions[competenceSocio.competence].libelle
                    "
                    :size-less="true"
                  />
                  <p class="line-clamp-3">
                    {{
                      competenceSocio.template.data[0].filter(
                        $filterEvaluationIntitulesMulti2
                      )[0].criterions[competenceSocio.competence].description
                    }}
                  </p>
                </div>
                <div
                  class="col-span-1 border-r border-indigo-600 border-opacity-50 h-full"
                />
                <div
                  v-for="(
                    beneficiary, beneficiaryIndex
                  ) in paginatedBeneficiaries"
                  :key="
                    'listevaluation-socio' +
                    competenceSocio.template.id +
                    competenceSocio.competence +
                    beneficiaryIndex
                  "
                  class="border-r border-indigo-600 border-opacity-50"
                  :class="
                    'col-span-3 md:col-span-1 flex text-center w-full h-full justify-center items-center  ' +
                    getLevelByBeneficiaryCompetence(
                      beneficiary,
                      competenceSocio
                    ).color
                  "
                >
                  {{
                    getLevelByBeneficiaryCompetence(
                      beneficiary,
                      competenceSocio
                    ).level
                  }}
                </div>
                <div class="col-span-1" />
              </div>
            </div>

            <!-- END CONTENT -->
          </div>
        </div>
        <!-- END Compétences socio-professionnelles -->

        <!-- BEGIN Compétences professionnelles -->
        <div v-if="filters.competences.pro.length > 0" class="mt-15 space-y-10">
          <div class="text-xl text-indigo-600 ml-10">
            Compétences professionnelles
          </div>
          <div v-for="sheet in listFilterSheets" :key="'sheetArray' + sheet.id">
            <div class="ml-5 md:ml-10 mb-5 md:mb-10 flex justify-between">
              <div class="text-lg">
                {{ sheet.name }}
              </div>
              <div>
                {{ filters.beneficiaries.length }} bénéficiaire{{
                  filters.beneficiaries.length > 1 ? 's' : ''
                }}
                sélectionné{{ filters.beneficiaries.length > 1 ? 's' : '' }}
              </div>
            </div>

            <!-- BEGIN HEADER -->
            <div
              class="grid grid-cols-12 min-h-16 text-base font-medium items-center border-b border-indigo-600 border-opacity-50"
            >
              <div class="col-span-2 pl-10 text-base font-medium">
                Compétences
              </div>
              <div
                class="col-span-1 border-r border-indigo-600 h-full border-opacity-50"
              >
                <div
                  v-if="beneficiariesPageNumber > 0"
                  @click.stop="
                    beneficiariesPageNumber = beneficiariesPageNumber - 1
                  "
                  class="h-full w-full flex items-center justify-center"
                >
                  <icon
                    name="arrow-circle-left"
                    class="text-indigo-600 h-8 w-8 transform hover:scale-125 duration-300 cursor-pointer"
                  />
                </div>
              </div>
              <div
                v-for="(
                  beneficiary, beneficiaryIndex
                ) in paginatedBeneficiaries"
                :key="'listBeneficiaries' + beneficiaryIndex"
                class="col-span-1 line-clamp-2 h-full border-r border-indigo-600"
              >
                <p class="break-words h-full text-center">
                  {{ beneficiary.firstname }} <br />
                  {{ beneficiary.lastname }}
                </p>
              </div>
              <div class="col-span-1">
                <div
                  v-if="
                    8 + beneficiariesPageNumber <=
                    filters.beneficiaries.length - 1
                  "
                  @click.stop="
                    beneficiariesPageNumber = beneficiariesPageNumber + 1
                  "
                  class="h-full w-full flex items-center justify-center"
                >
                  <icon
                    name="arrow-circle-right"
                    class="text-indigo-600 h-8 w-8 transform hover:scale-125 duration-300 cursor-pointer"
                  />
                </div>
              </div>
            </div>
            <!-- END HEADER -->
            <!-- BEGIN CONTENT -->
            <div class="divide-y divide-indigo-600 border-opacity-50">
              <div
                v-for="competencePro in listCompProBySheet[sheet.id]"
                :key="
                  'competence-pro' +
                  competencePro.sheet.id +
                  competencePro.activity +
                  competencePro.type +
                  competencePro.competence
                "
                class="grid grid-cols-12 min-h-12 text-base items-center odd:bg-indigo-100 odd:bg-opacity-50 bg-white"
              >
                <div
                  class="col-span-4 md:col-span-2 pl-5 md:pl-10 my-2 flex space-x-2 items-center"
                >
                  <p class="line-clamp-3">
                    {{
                      competencePro.sheet.data.activities[
                        competencePro.activity
                      ][competencePro.type][competencePro.competence].name
                    }}
                  </p>
                </div>
                <div
                  class="col-span-1 border-r border-indigo-600 border-opacity-50 h-full"
                />
                <div
                  v-for="(
                    beneficiary, beneficiaryIndex
                  ) in paginatedBeneficiaries"
                  :key="
                    'listevaluation-pro' +
                    competencePro.sheet.id +
                    competencePro.activity +
                    competencePro.type +
                    competencePro.competence +
                    beneficiaryIndex
                  "
                  class="border-r border-indigo-600 border-opacity-50"
                  :class="
                    'col-span-3 md:col-span-1 flex text-center w-full h-full justify-center items-center ' +
                    getLevelByBeneficiaryCompetencePro(
                      beneficiary,
                      competencePro
                    ).color
                  "
                >
                  {{
                    getLevelByBeneficiaryCompetencePro(
                      beneficiary,
                      competencePro
                    ).level
                  }}
                </div>
                <div class="col-span-1" />
              </div>
            </div>

            <!-- END CONTENT -->
          </div>
        </div>
        <!-- END Compétences professionnelles -->
      </div>
      <!-- END Présentation Tableau -->

      <!-- BEGIN Présentation Cartographies -->
      <div v-if="displayType === 'chart'" class="flex flex-col space-y-15">
        <div
          v-for="(
            beneficiary, beneficiaryIndex
          ) in filters.beneficiaries.filter((b) =>
            listEvaluations.some(
              (e) =>
                e.neopass_id === b.neopass_id &&
                (listFilterTemplateMulti3.some(
                  (tmp) => tmp.id === e.template_id
                ) ||
                  listFilterTemplateMulti2.some(
                    (tmp) => tmp.id === e.template_id
                  ) ||
                  listFilterSheets.some((sheet) => sheet.id === e.sheet_id))
            )
          )"
          :key="'listBeneficiaries' + beneficiaryIndex"
          class="flex flex-col space-y-5 justify-center items-center"
        >
          <div class="font-medium text-indigo-600">
            {{ beneficiary.firstname }} {{ beneficiary.lastname }}
          </div>
          <div class="flex space-x-5 justify-center items-center w-full">
            <div class="flex space-x-2 items-center">
              <div class="h-5 w-5 rounded-lg bg-pink-600" />
              <div class="text-sm">Non acquis</div>
            </div>
            <div class="flex space-x-2 items-center">
              <div class="h-5 w-5 rounded-lg bg-indigo-300" />
              <div class="text-sm">En apprentissage</div>
            </div>
            <div class="flex space-x-2 items-center">
              <div class="h-5 w-5 rounded-lg bg-teal-600" />
              <div class="text-sm">Acquis</div>
            </div>
          </div>
          <div class="flex flex-col space-y-5 items-center">
            <div
              v-for="(listPages, moduleName) in listPagesName"
              :key="moduleName"
              class="flex flex-wrap justify-center items-center space-x-5 space-y-5"
            >
              <div
                v-for="pageName in listPages.filter((pageName) =>
                  filters.competences[moduleName].some(
                    (comp) =>
                      pageName === comp.template.page.name &&
                      listEvaluations.some(
                        (e) =>
                          e.neopass_id === beneficiary.neopass_id &&
                          e.template_id === comp.template.id
                      )
                  )
                )"
                :key="pageName"
              >
                <div class="flex flex-col justify-center items-center">
                  <vue-gauge
                    :refid="
                      'type-unique-id-' + pageName + '-' + beneficiaryIndex
                    "
                    :class="'meticsGauge'"
                    :options="{
                      needleValue: getGaugeLevel(beneficiary, pageName),
                      centralLabel:
                        '' + getGaugeLevel(beneficiary, pageName) + '%',
                      needleColor: '#3A18D1',
                      arcDelimiters: [25, 50, 75],
                      arcColors: ['#FF1C80', '#DFE0F2', '#DFE0F2', '#21B8C8'],
                      arcOverEffect: true,
                      chartWidth: smallScreen ? 125 : 350,
                      hasNeedle: true,
                      rangeLabel: ['1', '5'],
                      arcLabels: ['2', '3', '4'],
                    }"
                  />
                  <p>
                    {{
                      filters.competences[moduleName].filter(
                        (comp) => comp.template.page.name === pageName
                      )[0].template.name
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="flex flex-col justify-center items-center">
              <div
                v-for="(sheet, compProIndex) in listFilterSheets.filter(
                  (sheet) =>
                    listEvaluations.some(
                      (e) =>
                        e.neopass_id === beneficiary.neopass_id &&
                        e.sheet_id === sheet.id
                    )
                )"
                :key="'sheetGauge' + compProIndex"
              >
                <div class="flex flex-col justify-center items-center">
                  <vue-gauge
                    :refid="
                      'type-unique-id-sheet' + sheet.id + '-' + beneficiaryIndex
                    "
                    :class="'meticsGauge'"
                    :options="{
                      needleValue: getGaugeLevelByCompPro(beneficiary, sheet),
                      centralLabel:
                        '' + getGaugeLevelByCompPro(beneficiary, sheet) + '%',
                      needleColor: '#3A18D1',
                      arcDelimiters: [25, 50, 75],
                      arcColors: ['#FF1C80', '#DFE0F2', '#DFE0F2', '#21B8C8'],
                      arcOverEffect: true,
                      chartWidth: smallScreen ? 125 : 350,
                      hasNeedle: true,
                      rangeLabel: ['1', '5'],
                      arcLabels: ['2', '3', '4'],
                    }"
                  />
                  <p>
                    {{ sheet.name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END Présentation Cartographies -->
    </div>

    <!-- BEGIN Display if no data in filter -->
    <div
      v-if="
        filters.beneficiaries.length === 0 ||
        (filters.competences.perso.length === 0 &&
          filters.competences.socio.length === 0 &&
          filters.competences.pro.length === 0)
      "
      class="flex flex-col space-y-5 p-10 justify-center items-center text-base"
    >
      <h4 class="text-indigo-600">Aucune donnée à afficher</h4>
      <p>
        <span v-if="filters.beneficiaries.length === 0">
          Aucun bénéficiaire
        </span>
        <span
          v-if="
            filters.beneficiaries.length === 0 &&
            filters.competences.perso.length === 0 &&
            filters.competences.socio.length === 0 &&
            filters.competences.pro.length === 0
          "
        >
          ni
        </span>
        <span
          v-if="
            filters.competences.perso.length === 0 &&
            filters.competences.socio.length === 0 &&
            filters.competences.pro.length === 0
          "
        >
          <span
            :class="{
              uppercase:
                filters.beneficiaries.length > 0 &&
                filters.competences.perso.length === 0 &&
                filters.competences.socio.length === 0 &&
                filters.competences.pro.length === 0,
            }"
            >a</span
          >ucune compétence
        </span>
        n'a été
        <span
          v-if="
            filters.beneficiaries.length > 0 &&
            filters.competences.perso.length === 0 &&
            filters.competences.socio.length === 0 &&
            filters.competences.pro.length === 0
          "
        >
          sélectionnée
        </span>
        <span v-else>sélectionné</span>
        dans les options de filtre.
      </p>
      <p>
        Veuillez choisir au moins un bénéficiaire
        <span class="underline">et</span> une compétence.
      </p>
      <action-button
        bg-color="bg-indigo-600"
        bg-color-square="bg-indigo-100"
        icon="options"
        icon-color="text-indigo-600"
        libelle="Choisir des filtres"
        text-color="text-white"
        @clickAction="isFilterPopupDisplayed = true"
      />
    </div>
    <!-- END Display if no data in filter -->
  </div>
</template>

<script>
import axios from '../../api';
import filtres from './popup/Filtres';
import Constants from '../../constants';
import VueGauge from 'vue-gauge';
import ActionButton from '../../components/ActionButton.vue';
import InfoBulle from '../../components/InfoBulle.vue';
import Icon from '../../components/Icon.vue';
import CompetencesLegend from './CompetencesLegend.vue';

export default {
  name: 'CompetencesModule',
  components: {
    CompetencesLegend,
    filtres,
    VueGauge,
    ActionButton,
    InfoBulle,
    Icon,
  },

  data() {
    return {
      constants: Constants,
      displayType: 'table',
      listTemplates: [],
      listEvaluations: [],
      isFilterPopupDisplayed: true,
      filters: {
        beneficiaries: [],
        competences: {
          perso: [],
          socio: [],
          pro: [],
        },
      },
      testEvaluation: [
        [2, 2, 3, 2, 2, 3, 4, 4, 1, 2],
        [1, 1, 3, 1, 2, 3, 3, 3, 1, 2],
        [1, 1, 3, 1, 3, 3, 4, 3, 1, 3],
        [4, 4, 4, 3, 4, 4, 3, 4, 4, 3],
        [2, 3, 2, 3, 3, 2, 3, 3, 3, 3],
        [2, 0, 0, 2, 0, 0, 2, 1, 0, 2],
        [4, 2, 3, 1, 2, 3, 1, 3, 4, 3],
        [1, 1, 3, 1, 3, 3, 4, 3, 1, 3],
        [4, 1, 4, 3, 3, 4, 3, 3, 4, 3],
        [1, 1, 3, 1, 3, 3, 4, 3, 1, 3],
      ],
      listPagesName: {
        perso: [
          Constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES,
          Constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE,
          Constants.PAGE_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES,
        ],
        socio: [
          Constants.PAGE_NEOPASS_FORM_APTITUDES_PERSONNELLES,
          Constants.PAGE_NEOPASS_FORM_COMPORTEMENT_SOCIAL_RELATIONNEL,
          Constants.PAGE_NEOPASS_FORM_APTITUDES_TRAVAIL,
          Constants.PAGE_NEOPASS_FORM_PRODUCTIVITE_TECHNICITE,
          Constants.PAGE_NEOPASS_FORM_ATTITUDES_TRAVAIL,
          Constants.PAGE_NEOPASS_FORM_RAPPORT_REGLES_CONTRAINTES,
        ],
      },

      criterionMax: 5,
      beneficiariesPageNumber: 0,

      //mediaquery manager
      smallScreen: false,
      mediaQuery: null,
    };
  },

  async mounted() {
    this.mediaQuery = window.matchMedia('(min-width: 768px)');

    let vm = this;
    function handleResize(e) {
      vm.smallScreen = !e.matches;
    }
    //Initial check
    handleResize(this.mediaQuery);

    this.mediaQuery.addEventListener('change', handleResize);

    await this.loadTemplatesList();
    await this.loadEvaluationsList();
  },

  methods: {
    async loadTemplatesList() {
      console.log('wait..Module competences load templates');
      /** datas for Front version */
      //this.listTemplates = ConstantsCompetences.templates;

      try {
        await axios.get('api/page_templates').then((response) => {
          this.listTemplates = response.data;
        });
      } catch (err) {
        console.error('ERROR::', err);
      }
    },

    async loadEvaluationsList() {
      console.log('wait..Module competences load evaluations');
      /** datas for Front version */
      //this.listEvaluations = ConstantsCompetences.evaluations;

      try {
        await axios.get('api/evaluations').then((response) => {
          this.listEvaluations = response.data;
        });
      } catch (err) {
        console.error('ERROR::', err);
      }
    },

    getLevelByBeneficiaryCompetence(beneficiary, competence) {
      let criterions;
      let criterionsKeys;
      let evaluation;
      let level;
      let color;

      /**
       * For a historied template, in template domains array, there is a first value with history informations, but there isn't it in evaluation data items.
       */
      let domainInEval =
        competence.template.data.length > 1
          ? competence.domaine - 1
          : competence.domaine;

      switch (competence.template.type) {
        case Constants.TEMPLATE_TYPES.multi1:
          return 'N/A';
        case Constants.TEMPLATE_TYPES.multi3: //For competences Personnelles
          // Récupération des critères d'évaluation
          criterions =
            competence.template.data[0][competence.domaine][
              competence.competence
            ].criterions;
          criterionsKeys = [...criterions.keys()];
          evaluation = this.listEvaluations.filter(
            (e) =>
              e.neopass_id === beneficiary.neopass_id &&
              e.template_id === competence.template.id
          )[0];
          level = criterionsKeys.filter(
            (key) =>
              evaluation?.data?.items[domainInEval]?.criterions &&
              criterions[key].value ===
                evaluation?.data?.items[domainInEval]?.criterions[
                  competence.competence
                ]
          )[0];
          break;

        case Constants.TEMPLATE_TYPES.multi2: //For competences Socio-professionnelles
          // Récupération des critères d'évaluation
          criterions = competence.template.data[0].filter(
            this.$filterCriterionsMulti2
          )[0].criterions;

          criterionsKeys = [...criterions.keys()];
          evaluation = this.listEvaluations.filter(
            (e) =>
              e.neopass_id === beneficiary.neopass_id &&
              e.template_id === competence.template.id
          )[0];
          level = criterionsKeys.filter(
            (key) =>
              criterions[key].value ===
              evaluation?.data.items[competence.competence]?.refEval
          )[0];
          break;
      }
      // Keep level when it's 1 because it is the lowest possible level (0 is "Non observable")
      level =
        level > 1
          ? (level / (criterions.length - 1)) * this.criterionMax
          : level;
      level = Math.round(level);

      color = 'text-transparent';
      if (level === 0) {
        color = 'bg-gray-600 text-white';
        level = 'N/O';
      }
      if (level === 1) color = 'bg-pink-600 text-white';
      if (level === 2) color = 'bg-indigo-300 text-gray-900';
      if (level === 3) color = 'bg-indigo-600 text-white';
      if (level === 4) color = 'bg-indigo-600 text-white';
      if (level === this.criterionMax) color = 'bg-teal-600 text-white';

      return {
        level: level,
        color: color,
      };
    },

    getLevelByBeneficiaryCompetencePro(beneficiary, competence) {
      let criterions;
      let criterionsKeys;
      let evaluation;
      let template;
      let level;
      let color;

      evaluation = this.listEvaluations
        .filter(
          (e) =>
            e.neopass_id === beneficiary.neopass_id &&
            e.sheet_id === competence.sheet.id
        )
        .sort((e1, e2) => new Date(e2.created_at) - new Date(e1.created_at))[0];

      template = evaluation?.data.template;

      // Récupération des critères d'évaluation
      criterions = template?.filter(
        (prop) => prop.libelle === 'Critères d\'évaluation'
      )[0]?.criterions;

      criterions = criterions ? this.getCriteria(criterions) : criterions;

      criterionsKeys = criterions ? [...criterions.keys()] : [];
      level = criterionsKeys
        ? criterionsKeys.filter(
          (key) =>
            criterions[key].value ===
              (evaluation?.data.items.activities[competence.activity][
                competence.type
              ][competence.competence]?.value || evaluation?.data.items.activities[competence.activity][
                competence.type
              ][competence.competence]?.auto)
        )[0]
        : 0;

      level =
        level > 0
          ? (level / (criterions.length - 1)) * this.criterionMax
          : level;
      level = Math.round(level);

      color = 'text-transparent';
      if (level === 0) {
        color = 'bg-gray-600 text-white';
        level = 'N/O';
      }
      if (level === 1) color = 'bg-pink-600 text-white';
      if (level === 2) color = 'bg-indigo-300 text-gray-900';
      if (level === 3) color = 'bg-indigo-600 text-white';
      if (level === 4) color = 'bg-indigo-600 text-white';
      if (level === this.criterionMax) color = 'bg-teal-600 text-white';

      return {
        level: level,
        color: color,
      };
    },

    getGaugeLevel(beneficiary, pageEvalName) {
      // Récupération des compétences filtrés qui concerne la page PageEvalName
      let competences = Object.keys(this.filters.competences)
        .filter(
          (moduleName) => moduleName != Constants.COMPETENCES_FILTER_TYPES.pro
        )
        .reduce(
          (acc, moduleKey) => [...acc, ...this.filters.competences[moduleKey]],
          []
        )
        .filter((comp) => comp.template.page.name === pageEvalName);

      // Liste de tous les niveaux évalués selon les compétences filtrés
      let listLevels = [];
      competences.forEach((competence) => {
        listLevels.push(
          this.getLevelByBeneficiaryCompetence(beneficiary, competence).level
        );
      });

      listLevels = listLevels.map((level) =>
        Number.isInteger(level) ? level : 0
      );

      return (
        (listLevels.reduce((acc, level) => acc + level, 0) /
          this.criterionMax) *
        20
      );
    },

    getGaugeLevelByCompPro(beneficiary, sheet) {
      let competences = this.filters.competences[
        Constants.COMPETENCES_FILTER_TYPES.pro
      ].filter((comp) => comp.sheet.id === sheet.id);

      // Liste de tous les niveaux évalués selon les compétences filtrés
      let listLevels = [];
      competences.forEach((competence) => {
        listLevels.push(
          this.getLevelByBeneficiaryCompetencePro(beneficiary, competence).level
        );
      });

      listLevels = listLevels.map((level) =>
        Number.isInteger(level) ? level : 0
      );

      return (
        (listLevels.reduce((acc, level) => acc + level, 0) /
          this.criterionMax) *
        20
      );
    },

    getGaugeLevelTest(beneficiaryIndex) {
      let cle = this.testEvaluation[beneficiaryIndex].filter((v, i) => i < 5);
      let info = this.testEvaluation[beneficiaryIndex].filter((v, i) => i >= 5);

      return {
        cle: (cle.reduce((acc, cur) => acc + cur, 0) / 5) * 25,
        info: (info.reduce((acc, cur) => acc + cur, 0) / 5) * 25,
      };
    },

    saveExcelSwapped() {
      const ExportJsonExcel = require('js-export-excel');

      let optionDatas = [];
      let optionData = {};
      let header = [];
      let datas = [];
      let widths = [];
      let line = [];

      // COMPETENCES PERSONNELLES
      if (this.filters.competences.perso.length > 0) {
        header = ['Compétences'];
        datas = [];
        widths = [10];

        this.filters.competences.perso.forEach((comp, compIndex) => {
          const currentCompPerso = this.competencesPersoToDisplay[compIndex];
          const template = currentCompPerso.template;
          const competence = currentCompPerso.competence;
          const domaine = currentCompPerso.domaine;
          const libelle = template.data[0][domaine][competence].libelle;
          const domainLibelle = template.data[0][domaine][0].libelle;

          const headerName = template.type === 'multi1'
            ? template.data[0][competence].libelle
            : libelle === domainLibelle
              ? libelle
              : `${domainLibelle} - ${libelle}`;
          header.push(headerName);
          widths.push(headerName.length / 2);
        });

        this.filters.beneficiaries.forEach((beneficiary) => {
          line = [];
          line.push(beneficiary.firstname + ' ' + beneficiary.lastname);
          this.filters.competences.perso.forEach((comp, compIndex) => {
            const currentCompPerso = this.competencesPersoToDisplay[compIndex];

            line.push(
              this.getLevelByBeneficiaryCompetence(
                beneficiary,
                currentCompPerso
              ).level
            );
          });
          datas.push(line);
        });

        optionData = {
          sheetName: 'Personnelles',
          sheetHeader: header,
          sheetData: datas,
          columnWidths: widths,
        };

        optionDatas.push(optionData);
      }

        // COMPETENCES SOCIO PROFESSIONNELLES
        if (this.filters.competences.socio.length > 0) {
          header = ['Compétences'];
          datas = [];
          widths = [15];

          this.filters.competences.socio.forEach((comp, compIndex) => {

            const headerName = this.competencesSocioToDisplay[compIndex]
              .template
              .data[0]
              .filter(this.$filterEvaluationIntitulesMulti2)[0]
              .criterions[this.competencesSocioToDisplay[compIndex].competence]
              .libelle;

            header.push(headerName);
            widths.push(headerName.length / 2);
          });


          this.filters.beneficiaries.forEach((beneficiary) => {
            line = [];
            line.push(beneficiary.firstname + ' ' + beneficiary.lastname);
            this.filters.competences.socio.forEach((comp, compIndex) => {
              line.push(
                this.getLevelByBeneficiaryCompetence(
                  beneficiary,
                  this.competencesSocioToDisplay[compIndex]
                ).level
              );
            });
            datas.push(line);
          });

          optionData = {
            sheetName: 'Socio-professionnelles',
            sheetHeader: header,
            sheetData: datas,
            columnWidths: widths,
          };

          optionDatas.push(optionData);
        }

      // COMPETENCES PROFESSIONNELLES
      if (this.filters.competences.pro.length > 0) {
        header = ['Compétences'];
        datas = [];
        widths = [15];

        this.filters.competences.pro.forEach((comp, compIndex) => {
          const activity = this.competencesProToDisplay[compIndex].activity;
          const type = this.competencesProToDisplay[compIndex].type;
          const competence = this.competencesProToDisplay[compIndex].competence;

          const headerName = this.competencesProToDisplay[compIndex]
            .sheet
            .data
            .activities[activity][type][competence]
            .name;

          header.push(headerName);
          widths.push(
            (headerName).length / 2
          );
        });

        this.filters.beneficiaries.forEach((beneficiary) => {
          line = [];
          line.push(beneficiary.firstname + ' ' + beneficiary.lastname);

          this.filters.competences.pro.forEach((comp, compIndex) => {
            line.push(
              this.getLevelByBeneficiaryCompetencePro(
                beneficiary,
                this.competencesProToDisplay[compIndex]
              ).level
            );
          });
          datas.push(line);
        });

        optionData = {
          sheetName: 'Professionnelles',
          sheetHeader: header,
          sheetData: datas,
          columnWidths: widths,
        };

        optionDatas.push(optionData);
      }

      let option = {};
      option.fileName = 'Compétences';
      option.datas = optionDatas;

      let toExcel = new ExportJsonExcel(option);
      toExcel.saveExcel();
    },

    saveExcel() {
      const ExportJsonExcel = require('js-export-excel');

      let optionDatas = [];
      let optionData = {};
      let header = [];
      let datas = [];
      let widths = [];
      let line = [];

      // COMPETENCES PERSONNELLES
      if (this.filters.competences.perso.length > 0) {
        header = ['Compétences'];
        datas = [];
        widths = [10];

        this.filters.beneficiaries.forEach((beneficiary) => {
          header.push(beneficiary.firstname + ' ' + beneficiary.lastname);
          widths.push(
            (beneficiary.firstname + ' ' + beneficiary.lastname).length / 2
          );
        });

        this.filters.competences.perso.forEach((comp, compIndex) => {
          line = [];
          line.push(
            this.competencesPersoToDisplay[compIndex].template.type === 'multi1'
              ? this.competencesPersoToDisplay[compIndex].template.data[0][
                  this.competencesPersoToDisplay[compIndex].competence
                ].libelle
              : this.competencesPersoToDisplay[compIndex].template.data[0][
                  this.competencesPersoToDisplay[compIndex].domaine
                ][this.competencesPersoToDisplay[compIndex].competence]
                  .libelle ===
                this.competencesPersoToDisplay[compIndex].template.data[0][
                  this.competencesPersoToDisplay[compIndex].domaine
                ][0].libelle
              ? this.competencesPersoToDisplay[compIndex].template.data[0][
                  this.competencesPersoToDisplay[compIndex].domaine
                ][this.competencesPersoToDisplay[compIndex].competence].libelle
              : this.competencesPersoToDisplay[compIndex].template.data[0][
                  this.competencesPersoToDisplay[compIndex].domaine
                ][0].libelle +
                ' - ' +
                this.competencesPersoToDisplay[compIndex].template.data[0][
                  this.competencesPersoToDisplay[compIndex].domaine
                ][this.competencesPersoToDisplay[compIndex].competence].libelle
          );
          this.filters.beneficiaries.forEach((beneficiary) => {
            line.push(
              this.getLevelByBeneficiaryCompetence(
                beneficiary,
                this.competencesPersoToDisplay[compIndex]
              ).level
            );
          });
          datas.push(line);
        });

        optionData = {
          sheetName: 'Personnelles',
          sheetHeader: header,
          sheetData: datas,
          columnWidths: widths,
        };

        optionDatas.push(optionData);
      }

      // COMPETENCES SOCIO PROFESSIONNELLES
      if (this.filters.competences.socio.length > 0) {
        header = ['Compétences'];
        datas = [];
        widths = [15];

        this.filters.beneficiaries.forEach((beneficiary) => {
          header.push(beneficiary.firstname + ' ' + beneficiary.lastname);
          widths.push(
            (beneficiary.firstname + ' ' + beneficiary.lastname).length / 2
          );
        });

        this.filters.competences.socio.forEach((comp, compIndex) => {
          line = [];
          line.push(
            this.competencesSocioToDisplay[compIndex].template.data[0].filter(
              this.$filterEvaluationIntitulesMulti2
            )[0].criterions[
              this.competencesSocioToDisplay[compIndex].competence
            ].libelle
          );
          this.filters.beneficiaries.forEach((beneficiary) => {
            line.push(
              this.getLevelByBeneficiaryCompetence(
                beneficiary,
                this.competencesSocioToDisplay[compIndex]
              ).level
            );
          });
          datas.push(line);
        });

        optionData = {
          sheetName: 'Socio-professionnelles',
          sheetHeader: header,
          sheetData: datas,
          columnWidths: widths,
        };

        optionDatas.push(optionData);
      }
      // COMPETENCES PROFESSIONNELLES
      if (this.filters.competences.pro.length > 0) {
        header = ['Compétences'];
        datas = [];
        widths = [15];

        this.filters.beneficiaries.forEach((beneficiary) => {
          header.push(beneficiary.firstname + ' ' + beneficiary.lastname);
          widths.push(
            (beneficiary.firstname + ' ' + beneficiary.lastname).length / 2
          );
        });

        this.filters.competences.pro.forEach((comp, compIndex) => {
          line = [];
          line.push(
            this.competencesProToDisplay[compIndex].sheet.data.activities[
              this.competencesProToDisplay[compIndex].activity
            ][this.competencesProToDisplay[compIndex].type][
              this.competencesProToDisplay[compIndex].competence
            ].name
          );
          this.filters.beneficiaries.forEach((beneficiary) => {
            line.push(
              this.getLevelByBeneficiaryCompetencePro(
                beneficiary,
                this.competencesProToDisplay[compIndex]
              ).level
            );
          });
          datas.push(line);
        });

        optionData = {
          sheetName: 'Professionnelles',
          sheetHeader: header,
          sheetData: datas,
          columnWidths: widths,
        };

        optionDatas.push(optionData);
      }

      let option = {};
      option.fileName = 'Compétences';
      option.datas = optionDatas;

      let toExcel = new ExportJsonExcel(option);
      toExcel.saveExcel();
    },

    getCriteria(criteria) {
      let isConjugable = false;

      for (const criterion of criteria) {
        if (
          criterion.value.startsWith('Je') ||
          criterion.value.startsWith('J’')
        ) {
          isConjugable = true;
          break;
        }
      }

      if (isConjugable) {
        return criteria.map((criterion) => {
          let value = criterion.value;
          value = value
            .replace('Je', 'Il')
            .replace('J’', 'Il ')
            .replace('me', 'se')
            .replace('m’', 's’')
            .replace('sais', 'sait')
            .replace('apprends', 'apprend')
            .replace('peux', 'peut');
          return {
            value: value,
          };
        });
      }

      return criteria;
    },
  },

  computed: {
    competencesPersoToDisplay() {
      return this.filters.competences[Constants.COMPETENCES_FILTER_TYPES.perso];
    },

    competencesSocioToDisplay() {
      return this.filters.competences[Constants.COMPETENCES_FILTER_TYPES.socio];
    },

    competencesProToDisplay() {
      return this.filters.competences[Constants.COMPETENCES_FILTER_TYPES.pro];
    },

    listCompPersoByTemplate() {
      return this.competencesPersoToDisplay.reduce((acc, comp) => {
        return {
          ...acc,
          [comp.template.id]: [...(acc[comp.template.id] || []), comp],
        };
      }, {});
    },

    listCompSocioProByTemplate() {
      return this.competencesSocioToDisplay.reduce((acc, comp) => {
        return {
          ...acc,
          [comp.template.id]: [...(acc[comp.template.id] || []), comp],
        };
      }, {});
    },

    listCompProBySheet() {
      return this.competencesProToDisplay.reduce((acc, comp) => {
        return {
          ...acc,
          [comp.sheet.id]: [...(acc[comp.sheet.id] || []), comp],
        };
      }, {});
    },

    listNumCompPerso() {
      return [...Array(this.competencesPersoToDisplay.length).keys()];
    },

    listNumCompSocio() {
      return [...Array(this.competencesSocioToDisplay.length).keys()];
    },

    listNumCompPro() {
      return [...Array(this.competencesProToDisplay.length).keys()];
    },

    paginatedBeneficiaries() {
      return this.filters.beneficiaries.filter(
        (beneficiary, index) =>
          index <
            this.nbBeneficiariesDisplayed + this.beneficiariesPageNumber &&
          index >= this.beneficiariesPageNumber
      );
    },

    nbBeneficiariesDisplayed() {
      return this.smallScreen ? 2 : 8;
    },

    listFilterTemplateMulti3() {
      return this.filters.competences[
        Constants.COMPETENCES_FILTER_TYPES.perso
      ].reduce(
        (acc, comp) =>
          acc.includes(comp.template) ? acc : [...acc, comp.template],
        []
      );
    },

    listFilterTemplateMulti2() {
      return this.filters.competences[
        Constants.COMPETENCES_FILTER_TYPES.socio
      ].reduce(
        (acc, comp) =>
          acc.includes(comp.template) ? acc : [...acc, comp.template],
        []
      );
    },

    listFilterSheets() {
      return this.filters.competences[
        Constants.COMPETENCES_FILTER_TYPES.pro
      ].reduce(
        (acc, comp) => (acc.includes(comp.sheet) ? acc : [...acc, comp.sheet]),
        []
      );
    },
  },
};
</script>
